/**
 * Heurística para sugerir que uma linha do OFX é, na verdade, transferência entre
 * contas. Usa palavras-chave comuns em descrições de bancos brasileiros (TED, DOC,
 * PIX entre contas próprias, transferência interna). É só uma sugestão — o usuário
 * pode aceitar ou trocar manualmente na decisão por linha do PreviewStep.
 */
const TRANSFER_KEYWORDS = [
  'transferencia',
  'transferência',
  'transf ',
  'transf.',
  'transf-',
  'ted ',
  'doc ',
  'pix env',
  'pix recebido',
  'pix enviado',
  'envio pix',
  'recebimento pix',
  'aplicacao',
  'aplicação',
  'resgate',
  'rendimento',
  'invest auto',
];

function normalize(s: string): string {
  return s
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '');
}

/** Retorna true se a descrição sugere transferência entre contas. */
export function looksLikeTransfer(description: string): boolean {
  const norm = normalize(description);
  return TRANSFER_KEYWORDS.some((kw) => norm.includes(normalize(kw)));
}
